<template>
  <div>
   <div class="card" v-for="(item,index) in list" :key="index">
      <div class="card-top">
        <div class="title u-line2">{{item.name}}</div>
        <div class="dz" style="margin-bottom: 6rpx;">地址：{{item.address}}</div>
        <div class="dz" >电话：{{item.phone}}</div>
      </div>
      <div class="card-bottom">
         <div class="btn" @click="goDetail(item)">立即预约</div>
      </div>
   </div>
   </div>
</template>



<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
      obj:{},
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (item) {
      let params = { id: item.id }
      this.$router.push({
        path: '/dqfw/hdsyy-view',
        query: params,
      })
    },
  },
}
</script>

<style lang="less" scoped>
  
  .card{
    margin: 0 15px 12px;
    height: auto;
    background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0 0 4px 0 #0000001a;
    border-radius: 8px;
    
    .card-top{
      padding: 12px;
      
      .title{
        font-size: 16px;
        color: #1A1A1A;
        margin-bottom: 10px;
      }
      
      .dz{
        font-size: 14px;
        color: #676767;
      }
      
    }
    .card-bottom{
      height: 50px;
      border-top: 1px solid #E0E0E0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      .btn{
        width: 185px;
        height: 30px;
        background: #4C71E3;
        border-radius: 15px;
        text-align: center;
        line-height: 30px;
        color: #FFFFFF;
      }
    }
  }

</style>
